import { Component, OnInit, ViewChild } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FilterpopupComponent } from '../../grid/filterpopup/filterpopup.component';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';

@Component({
  selector: 'app-paymentlistviewreport',
  templateUrl: './paymentlistviewreport.component.html',
  styleUrls: ['./paymentlistviewreport.component.css']
})
export class PaymentlistviewreportComponent implements OnInit  {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  formname: string = "PaymentListviewReport";

  filterstatus: string = "";
  dtOptions: DataTables.Settings = {};

  formColl: any = [];
  statusColl: any = [];
  paymentlistColl: any = [];

  paymentform: string = "";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterbranchid: any = null;
  filterbranchname: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;

 
  searchtxt: any = "";
  
  columnDefs = [
    { headerName: 'Form', field: 'trxtype' },
    { headerName: 'Employee', field: 'empname' },
    { headerName: 'Remarks', field: 'typename' },
    {
        headerName: 'Date', field: 'transdt', type:'date'    
    },
 
    { headerName: 'Status', field: 'paymentstatus' },
  ]
  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private datePipe: DatePipe) {
  
    this.fnServiceChanges();
  }



  //Company Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fngetPaymentListview();
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {

      if (this.loginService.fnCheckCompany()) {
        this.fngetPaymentListview();
      }
      this.fnGetForms();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnGetForms() {
  
    this.formColl = [];
    this.formColl.push({ name: '', displayname: 'All Forms' });
    this.formColl.push({ name: 'BONUS', displayname: 'Bonus' });
    this.formColl.push({ name: 'FINE', displayname: 'Fine' });
    this.formColl.push({ name: 'LOAN', displayname: 'Loan' });
    this.formColl.push({ name: 'PAYADVANCE', displayname: 'PayAdvance' });
    this.formColl.push({ name: 'REIMBURSE', displayname: 'Reimburse' });
    this.formColl.push({ name: 'TRAINING', displayname: 'Training' });
   
  }


  


  fnActionFilterClick() {

     this.fnShowFilterPopup();
  }


  fnApplyFilterPop(data) {
  
    this.filteremployeeid = data.empid;
    this.filteremployeename = data.empname;
    this.filterbranchid = data.branchid;
    this.filterbranchname = data.branchname;
    this.filterfromdate = data.fromdate;
    this.filtertodate = data.todate;
    this.filterstatus=data.status

    this.fngetPaymentListview();
     
  }

  fnApplyFilter(data) {

    this.filterstatus = data;

    this.fngetPaymentListview();

  }
  


  //Get
  fngetPaymentListview() {
  
    var data = {
      'formname': this.paymentform,
      'companyid': this.loginService.fnGetCompanyId(),
      'status': this.filterstatus,
      'empid': this.filteremployeeid, 
      'branchid': this.filterbranchid,
      'fromdate':this.fnFormatDatetime(this.filterfromdate),
      'todate':this.fnFormatDatetime(this.filtertodate), 
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    
    this.appService.getPaymentListviewReport(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.paymentlistColl = res.json().result;
            console.log(this.paymentlistColl)
            this.fnSetTable();
         

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnShowFilterPopup() {

  const modalRef = this.productFindService.open(FilterpopupComponent, { size: <any>'l' });
  modalRef.componentInstance.formname = this.formname;

  modalRef.componentInstance.employeeid = Number(this.filteremployeeid);
  modalRef.componentInstance.branchid =  !this.filterbranchid ? null :Number(this.filterbranchid);

  modalRef.componentInstance.fromdate = this.filterfromdate;
  modalRef.componentInstance.todate = this.filtertodate;
 

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
    
    if (receivedEntry.status === 'DONE') {
     
      this.filteremployeeid = receivedEntry.employeeid;
      this.filteremployeename = receivedEntry.empname;
      this.filterbranchid = receivedEntry.branchid;
      this.filterbranchname = receivedEntry.branchname;
      this.filterfromdate=receivedEntry.fromdate;
      this.filtertodate=receivedEntry.todate;
    
      this.fngetPaymentListview();
    }


  });
}
  
private fnExport() {

  const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
  modalRef.componentInstance.doctype = this.formname;
  modalRef.componentInstance.columnDefs = this.columnDefs;
  modalRef.componentInstance.contentColl = this.paymentlistColl;
  modalRef.componentInstance.fnSetTable();
  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  
  });

} 

  fnSetTable() {
 
  }

  public fnSearchDatatable(value) {
 //   this.gridApi.setQuickFilter(value);
  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.paymentlistColl[index].hoverfocus = "IN"
      }
      else {
        this.paymentlistColl[index].hoverfocus = ""
      }
    }
  }
  fnCloseForm() {
    try {
      this.router.navigate(['/Reports']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }
  
    } else {
      return null
    }
  }  
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }










}
